import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { CxAlertsService } from './../../../libs/components/cx-alerts/cx-alerts.service';
import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { AuthService } from '@app/auth/auth.service';
import IdleTimer from "../../../auth/IdleTimer";
@Component({
  selector: 'app-common-page',
  templateUrl: './common-page.component.html',
  styleUrls: ['./common-page.component.scss']
})
export class CommonPageComponent implements OnInit {
  public isConnected = true;

  visibilitySuccsessAlert: boolean = false;
  visibilityWarnAlert: boolean = false;
  visibilityInfoAlert: boolean = false;

  messageSuccsessAlert: string = '';
  messageWarnAlert: string = '';
  messageInfoAlert: string = '';
  timeSixHoursBefore: boolean = false;

  displayExpira = false;
  timedOut = false;
  lastPing?: Date = null;

  timer: any;

  constructor(
      private alertService: CxAlertsService,
      private connectionService: ConnectionService,
      private idle: Idle,
      private keepalive: Keepalive,
      private authService: AuthService
    ) {

    this.connectionService.monitor().subscribe(connected => {
      this.isConnected = connected.hasNetworkConnection;
    });
    this.timedOut = JSON.parse(localStorage.getItem('expired'));
  }

  ngOnInit(): void {

    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (!isOnline) {
      this.isConnected = isOnline;
    }
    /** Visibility **/
    this.alertService.visibilityAlertSuccess.subscribe(visibility => this.visibilitySuccsessAlert = visibility);
    this.alertService.visibilityAlertWarn.subscribe(visibility => this.visibilityWarnAlert = visibility);
    this.alertService.visibilityAlertInfo.subscribe(visibility => this.visibilityInfoAlert = visibility);
    /** Messages **/
    this.alertService.messageAlertSuccess.subscribe(message => this.messageSuccsessAlert = message);
    this.alertService.messageAlertWarn.subscribe(message => this.messageWarnAlert = message);
    this.alertService.messageAlertInfo.subscribe(message => this.messageInfoAlert = message);

    this.timer = new IdleTimer({
      timeout: 10,
      onTimeout: () => {
        localStorage.setItem('expired', 'true')
        this.timedOut = true;
      }
    });


  }

  ngOnDestroy(): void {

    localStorage.removeItem('expired');
    localStorage.removeItem('ng2Idle.main.expiry');
    localStorage.removeItem('ng2Idle.main.idling');
    this.timer.cleanUp();
  }

  buildMessageOfflineExpiration(): string {
    /**
     * TODO: Buscar info en DB, inyectar servicio
     */
    const usersOffline = JSON.parse(localStorage.getItem('offlineUsers'));

    if(usersOffline !== undefined && usersOffline !== null){

    const expirationDate = usersOffline.expirationDate;

    //console.log('FECHA EXPIRACION ' + new Date(expirationDate).getTime());

    const today = new Date();
    const hoursRemaining = Math.abs(new Date(expirationDate).getTime() - today.getTime()) / 3600000;

    if (hoursRemaining <= 6) {
        this.timeSixHoursBefore = true;
    }else{
        this.timeSixHoursBefore = false;
    }
      return 'Se podrá loguear de manera Offline con este usuario hasta las ' + formatDate(expirationDate, 'hh:mm a', 'en') + ' del ' + formatDate(expirationDate, 'dd/M/yyyy', 'en');
    }

    return '';
  }

  logout(){

    this.authService.logout();
    this.timedOut = false;
  }

}
